import { Location } from 'src/app/models/location';
export interface Contacts {
  UserGuid: string;
  FirstName: string;
  MiddleName: string;
  LastName: string;
  IsStudentAdmin: boolean;
  IsLeadAdmin: boolean;
  IsProctor: boolean;
  LocationId: string;
  PhoneNumber: string;
  EmailAddress: string;
}

export interface ContactsResult {
  value: Contacts[];
  context: string;
}

export interface Proctor {
  FirstName: string;
  MiddleName: string;
  LastName: string;
  LocationId: string;
  PhoneNumber: string;
  EmailAddress: string;
  ExamEmailAddress: string;
  Id: string;
}

export interface ProctorResult {
  value: Proctor[];
  context: string;
}

export interface leadResult {
  locationChoice: Location;
  showHide: boolean;
}
export interface studentAdminResult {
  locationChoice: Location;
  showHide: boolean;
}
export interface proctorResult {
  locationChoice: Location;
  showHide: boolean;
}

export enum people {
  leadAdmin = 1,
  studentAdmin = 2,
  proctor = 3,
}
